<div class="animated fadeIn" style="overflow: hidden;">
  <div class="card">

    <div class="card-body" [style]="{'border': '1px solid red!important;'}">

      <div class="row">
        <div class="col-sm-3 col-md-3">

          <p-table #dtModel [columns]="cols" [loading]="loading" selectionMode="single" [(selection)]="selectedSocifact"
            [value]="socifact" [globalFilterFields]="['designation','objet' ]" [scrollable]="true">


            <ng-template pTemplate="caption">
              <div style="text-align: right">

                <span *ngIf='socifact'>

                  {{socifact.length}} Sociétés </span>
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText placeholder="Global Filter"
                  (input)="dtModel.filterGlobal($event.target.value, 'contains')" style="width:auto">
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>

                <th [style]="{'width':'300px'}">
                  <button type="button" (click)="createSocifact()" class="btn btn-sm btn-warning">
                    <i class="icon-plus"></i> New </button>

                </th>
                <th [style]="{'width':'5px!important'}" data-ng-style="5" *ngFor="let col of cols"
                  [pSortableColumn]="col.field">
                  <p-sortIcon [style]="{'width':'5px!important'}" [field]="col.field"></p-sortIcon>

                </th>
                <th [style]="{'width':'50px'}">
                  <button type="button" (click)="removeSocifact()" [disabled]='!selectedSocifact'
                    class="btn btn-sm btn-danger">
                    <i class="fa fa-remove"></i>Remove
                  </button>
                </th>
              </tr>

            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData"
                [ngStyle]="{'background-color': (selectedSocifact) &&  (rowData.sociFactId === selectedSocifact.sociFactId) ? '#ef8b00' :'white'  }">


                <td>
                  {{rowData.designation}}
                  <span class="badge " [style.background-color]="'red'"> </span>
                </td>



              </tr>
            </ng-template>



          </p-table>


        </div>
        <div class="col-sm-9 col-md-9">
          <div *ngIf='selectedSocifact'>


            <div class="row">
              <div class="col-10">
                <div [style.font-size]=" '23px' " [style.color]=" 'red' " *ngIf='!isEdit'>
                  <strong>{{selectedSocifact.designation | uppercase}}</strong>
                </div>
              </div>
              <div class="col-2">
                <button *ngIf='!isEdit' type="button" (click)="isEdit=true;  " class="btn btn-sm btn-outline-primary">
                  <i class="fa fa-edit"></i> Edit </button>
                <button *ngIf='isEdit' type="button" (click)="isEdit=false;save()"
                  class="btn btn-sm btn-outline-primary">
                  <i class="fa fa-save"></i> Save </button>
                <button *ngIf='isEdit' type="button" (click)="isEdit=false;" class="btn btn-sm btn-outline-danger">
                  <i class="fa fa-remove"></i> Cancel</button>
              </div>
            </div>
            <br />
            <div class="row">

              <label class="col-md-1 ">
                <strong> Designation:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.designation">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.designation }}</span>

              <br />

            </div>


            <div class="row">




              <label class="col-md-1 ">
                <strong> Raison Sociale:</strong>
              </label>

              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.raisonSocial">

              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.raisonSocial }}</span>


              <br />
            </div>
            <div class="row">




              <label class="col-md-1 ">
                <strong> Entéte:</strong>
              </label>

              <p-fileUpload *ngIf="isEdit" name="name" url="{{uploadUrl}}" mode="basic" auto="true"
                chooseLabel="Choose EnTéte" (onUpload)="uploadFunction($event)" [multiple]="false"
                maxFileSize="100000000">

              </p-fileUpload>
              <p-button *ngIf="isEdit" (click)="saveFile('tete')" icon="pi pi-save" label="Save file"></p-button>




              <br />
            </div>
    
            <div class="row">
              <img [src]="'data:image/png;base64,'+selectedSocifact.tete" height="150"
                style="width: 100%;margin: 20px;">
            </div>
            <div class="row">




              <label class="col-md-1 ">
                <strong> Entéte Edition:</strong>
              </label>

              <p-fileUpload *ngIf="isEdit" name="name" url="{{uploadUrl}}" mode="basic" auto="true"
                chooseLabel="Choose EnTéte Edition" (onUpload)="uploadFunction($event)" [multiple]="false"
                maxFileSize="100000000">

              </p-fileUpload>
              <p-button *ngIf="isEdit" (click)="saveFile('edition')" icon="pi pi-save" label="Save file"></p-button>




              <br />
            </div>
            <div class="row">
              <img [src]="'data:image/png;base64,'+selectedSocifact.teteEditionBlob" height="250"
                style="width: 100%;margin: 20px;">
            </div>


            <div class="row">




              <label class="col-md-1 ">
                <strong> Signature:</strong>
              </label>

              <p-fileUpload *ngIf="isEdit" name="name" url="{{uploadUrl}}" mode="basic" auto="true"
                chooseLabel="Choose Signature" (onUpload)="uploadFunction($event)" [multiple]="false"
                maxFileSize="100000000">

              </p-fileUpload>

              <p-button *ngIf="isEdit" (click)="saveFile('signature')" icon="pi pi-save" label="Save file"></p-button>



              <br />
            </div>

            <div class="row">
              <img [src]="'data:image/png;base64,'+selectedSocifact.signature" height="150" height="150">
            </div>





            <br />

            <div class="row">

              <label class="col-md-1 ">
                <strong> Banque:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.banque">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.banque }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong> Adresse:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.adresse">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.adresse }}</span>

              <br />

            </div>

            <div class="row">

              <label class="col-md-1 ">
                <strong> Adresse Banque:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.adresseBanque">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.adresseBanque }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong>Ville:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.ville">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.ville }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong> Agence:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.agence">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.agence }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong>Gérant:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.gerant">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.gerant }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong>Iban:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.iban">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.iban }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong>Swift:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.swift">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.swift }}</span>

              <br />

            </div>
            <div class="row">

              <label class="col-md-1 ">
                <strong>Numero:</strong>
              </label>
              <input *ngIf="isEdit" class="col-md-11" type="text" class="form-control"
                [(ngModel)]="selectedSocifact.numero">
              <span *ngIf="!isEdit" class="col-md-11">{{selectedSocifact.numero }}</span>

              <br />

            </div>

            <div class="row">

              <label class="col-md-1 ">
                <strong>Text Visa:</strong>
              </label>
         

                <p-editor *ngIf="isEdit" class="col-md-11"  
                [(ngModel)]="selectedSocifact.textVisa"   [style]="{'height':'120px'}"></p-editor>
                <ckeditor  class="col-md-11" [(ngModel)]="selectedSocifact.textVisa" [config]="CkeditorConfig1" [readonly]="true" *ngIf="!isEdit" debounce="500">
  
  
                </ckeditor>
 
              <br />

            </div>

            <div class="row" style="margin-bottom: 500px;">

              <label class="col-md-1 ">
                <strong>Text Douane:</strong>
              </label>
           

                <p-editor *ngIf="isEdit" class="col-md-11"  
                [(ngModel)]="selectedSocifact.textDouane"   [style]="{'height':'120px'}"></p-editor>
            
              <ckeditor  class="col-md-11" [(ngModel)]="selectedSocifact.textDouane" [config]="CkeditorConfig1" [readonly]="true" *ngIf="!isEdit" debounce="500">
  
  
              </ckeditor>
              <br />

            </div>

           

          </div>

        </div>
      </div>


    </div>

  </div>